import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUndoRegular = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 512 480",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M155.37 124.422C155.37 110.774 166.433 99.7102 180.081 99.7102H321.878C415.724 99.7102 511.336 175.05 511.336 289.168C511.336 403.287 415.724 478.626 321.878 478.626H190.081C176.433 478.626 165.37 467.562 165.37 453.914C165.37 440.266 176.433 429.202 190.081 429.202H321.878C391.791 429.202 461.913 372.745 461.913 289.168C461.913 205.592 391.791 149.134 321.878 149.134H180.081C166.433 149.134 155.37 138.07 155.37 124.422Z"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M168.188 3.4716C176.56 7.6576 181.848 16.2144 181.848 25.5746V223.27C181.848 232.63 176.56 241.187 168.188 245.373C159.816 249.559 149.797 248.656 142.309 243.039L10.5122 144.192C4.2896 139.525 0.627441 132.201 0.627441 124.422C0.627441 116.644 4.2896 109.32 10.5122 104.653L142.309 5.80507C149.797 0.188964 159.816 -0.714403 168.188 3.4716Z"
	})]
});
export default SvgUndoRegular;
